import React from "react";

const StaticMap = ({ mapUrl, divClass }) => {
  return (
    <div className={`map ${divClass || ""}`}>
      <img
        width="100%"
        style={{
          WebkitUserSelect: "none",
          margin: "auto",
          cursor: "zoom-in"
        }}
        src={mapUrl}
      />
    </div>
  );
};

export default StaticMap;
